import { Laboratory } from './laboratory';
import { PaginationData } from './pagination-data.model';
import { Role } from './role';

export class User {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  id?: number;
  role?: Role;
  token?: string;
  laboratories?: Laboratory[];
  organisationId?: number;
  organisationName?: string;
  isMemberOfMultipleLabGroups?: boolean;
  createdAt?: number;
  userStatus?: UserStatus;
  isLockedOut?: boolean;
  isDisabled?: boolean;
  labNames?: string[];
  twoFactorSetupRequired?: boolean;
  twoFactorEnabled?: boolean;
  recoveryCodesRemaining?: number;

  constructor(
    email: string,
    firstName: string,
    lastName: string,
    phoneNumber?: string,
    id?: number,
    role?: Role,
    token?: string,
  ) {
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.phoneNumber = phoneNumber;
    this.id = id || null;
    this.role = role || null;
    this.token = token || null;
  }
}

export class UserCreate {
  firstName: string;
  lastName: string;
  email: string;
  userType: Role;
  laboratoryIds: number[];
}

export class UserUpdate {
  id: number;
  firstName?: string;
  lastName?: string;
  userRole?: Role;
  laboratoryIds?: number[];
}

export class UserIndex {
  users: User[];
  paginationData: PaginationData;
}

export enum UserStatus {
  Active = 1,
  InviteSent = 2,
  InviteExpired = 3,
  AwaitingConfirmation = 4,
  AwaitingConfirmationExpired = 5,
  PendingUpdateEmailConfirmation = 6,
  PendingUpdateEmailConfirmationExpired = 7
}


export const UserStatusPrimaryDisplay: Record<UserStatus, string> = {
  [UserStatus.Active]: 'Active',
  [UserStatus.InviteSent]: 'Invite Sent',
  [UserStatus.InviteExpired]: 'Invite Expired',
  [UserStatus.AwaitingConfirmation]: 'Unverified',
  [UserStatus.AwaitingConfirmationExpired]: 'Unverified',
  [UserStatus.PendingUpdateEmailConfirmation]: 'Active',
  [UserStatus.PendingUpdateEmailConfirmationExpired]: 'Active',
};

export const UserStatusSecondaryLabel: Record<UserStatus, string | null> = {
  [UserStatus.Active]: null,
  [UserStatus.InviteSent]: null,
  [UserStatus.InviteExpired]: null,
  [UserStatus.AwaitingConfirmation]: 'Pending email confirmation',
  [UserStatus.AwaitingConfirmationExpired]: 'Confirmation link expired',
  [UserStatus.PendingUpdateEmailConfirmation]: 'Pending email update',
  [UserStatus.PendingUpdateEmailConfirmationExpired]: 'Email update link expired',
};
